import { object, string, number } from 'yup';

export default object().shape({
    Names:
        string()
            .required('REQUIRED'),
    LastNames:
        string()
            .required('REQUIRED'),
    MobileNumber:
        string()
            .required('REQUIRED')
            .matches(/^\d{6,15}$/, 'INVALID_PHONE'),
    Emails:
        string()
            .required('REQUIRED')
            .email('INVALID_EMAIL'),
    Language:
        string()
            .required('REQUIRED'),
    Status:
        number()
            .required('REQUIRED')
});
